import { Route, Routes } from "react-router-dom";
import { ManageInterviews } from "Modules/Core/Help/HelpPages/ManageInterviews";
import { ManagingCandidates } from "Modules/Core/Help/HelpPages/ManagingCandidates";
import { SetPermissions } from "Modules/Core/Help/HelpPages/SetPermissions";
import { BillingAndPayments, ContactSupport, GettingStarted, PostAJob } from "Modules/Core/Help";
import { AccountCustomization } from "Modules/Core/Help/HelpPages/AccountCustomization";
import AccountSecurity from "Modules/Core/Help/HelpPages/AccountSecurity";
import { Help } from "Modules/Core/Help/Help";
import { OptimizeJobPosting } from "Modules/Core/Help/HelpPages/OptimizeJobPosting";
import { Careers } from "Modules/Core/Help/HelpPages/Careers";
import { Tasks } from "Modules/Core/Help/HelpPages/Tasks";
import DashboardHelp from "Modules/Core/Help/HelpPages/DashboardHelp";
import CalendarHelp from "Modules/Core/Help/HelpPages/CalendarHelp";
import AnalyticsHelp from "Modules/Core/Help/HelpPages/AnalyticsHelp";
import ApplicantManagementHelp from "Modules/Core/Help/HelpPages/ApplicantManagementHelp";
import InterviewManagementHelp from "Modules/Core/Help/HelpPages/InterviewManagementHelp";
import AccountSettingsHelp from "Modules/Core/Help/HelpPages/AccountSettingsHelp";
import BillingHelp from "Modules/Core/Help/HelpPages/BillingHelp";
import CareerPagesHelp from "Modules/Core/Help/HelpPages/CareerPagesHelp";
import EmailTemplatesHelp from "Modules/Core/Help/HelpPages/EmailTemplatesHelp";
import FormTemplatesHelp from "Modules/Core/Help/HelpPages/FormTemplatesHelp";
import AutoRejectHelp from "Modules/Core/Help/HelpPages/AutoRejectHelp";
import InterviewRemindersHelp from "Modules/Core/Help/HelpPages/InterviewRemindersHelp";
import NotificationsHelp from "Modules/Core/Help/HelpPages/NotificationsHelp";
import SecuritySettingsHelp from "Modules/Core/Help/HelpPages/SecuritySettingsHelp";
import AccessLevelsHelp from "Modules/Core/Help/HelpPages/AccessLevelsHelp";
import CompanyInfoHelp from "Modules/Core/Help/HelpPages/CompanyInfoHelp";

// Import new help pages
import JobPostingHelp from "Modules/Core/Help/HelpPages/JobPostingHelp";
import CandidateScreeningHelp from "Modules/Core/Help/HelpPages/CandidateScreeningHelp";
import TeamCollaborationHelp from "Modules/Core/Help/HelpPages/TeamCollaborationHelp";
import ReferenceCheckingHelp from "Modules/Core/Help/HelpPages/ReferenceCheckingHelp";
import OfferManagementHelp from "Modules/Core/Help/HelpPages/OfferManagementHelp";
import OnboardingHelp from "Modules/Core/Help/HelpPages/OnboardingHelp";
import ComplianceHelp from "Modules/Core/Help/HelpPages/ComplianceHelp";
import IntegrationsHelp from "Modules/Core/Help/HelpPages/IntegrationsHelp";

export const HelpRouter = () => {
    return (
        <Routes>
            {/* Help */}
            <Route path="/" element={<Help />} />
            <Route path="/getting-started" element={<GettingStarted />} />
            <Route path="/managing-candidates" element={<ManagingCandidates />} />
            <Route path="/optimize-job-posting" element={<OptimizeJobPosting />} />
            <Route path="/account-customization" element={<AccountCustomization />} />
            <Route path="/account-security" element={<AccountSecurity />} />
            <Route path="/billing-payments" element={<BillingAndPayments />} />
            <Route path="/contact-support" element={<ContactSupport />} />
            <Route path="/set-permissions" element={<SetPermissions />} />
            <Route path="/post-a-job" element={<PostAJob />} />
            <Route path="/manage-interviews" element={<ManageInterviews />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/tasks" element={<Tasks />} />

            {/* New Help Pages */}
            <Route path="/dashboard" element={<DashboardHelp />} />
            <Route path="/calendar" element={<CalendarHelp />} />
            <Route path="/analytics" element={<AnalyticsHelp />} />
            <Route path="/applicants" element={<ApplicantManagementHelp />} />
            <Route path="/interviews" element={<InterviewManagementHelp />} />
            <Route path="/account-settings" element={<AccountSettingsHelp />} />
            <Route path="/billing" element={<BillingHelp />} />
            <Route path="/career-pages" element={<CareerPagesHelp />} />
            <Route path="/email-templates" element={<EmailTemplatesHelp />} />
            <Route path="/form-templates" element={<FormTemplatesHelp />} />
            <Route path="/auto-reject" element={<AutoRejectHelp />} />
            <Route path="/interview-reminders" element={<InterviewRemindersHelp />} />
            <Route path="/notifications" element={<NotificationsHelp />} />
            <Route path="/security-settings" element={<SecuritySettingsHelp />} />
            <Route path="/access-levels" element={<AccessLevelsHelp />} />
            <Route path="/company-information" element={<CompanyInfoHelp />} />

            {/* Additional Help Pages */}
            <Route path="/job-posting" element={<JobPostingHelp />} />
            <Route path="/candidate-screening" element={<CandidateScreeningHelp />} />
            <Route path="/team-collaboration" element={<TeamCollaborationHelp />} />
            <Route path="/reference-checking" element={<ReferenceCheckingHelp />} />
            <Route path="/offer-management" element={<OfferManagementHelp />} />
            <Route path="/onboarding" element={<OnboardingHelp />} />
            <Route path="/compliance" element={<ComplianceHelp />} />
            <Route path="/integrations" element={<IntegrationsHelp />} />
        </Routes>
    );
};
